function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0002 2.66699C12.3242 2.66699 9.3335 5.65766 9.3335 9.33366V12.0003H8.00016C6.5295 12.0003 5.3335 13.1963 5.3335 14.667V26.667C5.3335 28.1377 6.5295 29.3337 8.00016 29.3337H24.0002C25.4708 29.3337 26.6668 28.1377 26.6668 26.667V14.667C26.6668 13.1963 25.4708 12.0003 24.0002 12.0003H22.6668V9.33366C22.6668 5.65766 19.6762 2.66699 16.0002 2.66699ZM12.0002 9.33366C12.0002 7.12833 13.7948 5.33366 16.0002 5.33366C18.2055 5.33366 20.0002 7.12833 20.0002 9.33366V12.0003H12.0002V9.33366ZM24.0028 26.667H17.3335V23.6297C18.1268 23.167 18.6668 22.3163 18.6668 21.3337C18.6668 19.863 17.4708 18.667 16.0002 18.667C14.5295 18.667 13.3335 19.863 13.3335 21.3337C13.3335 22.315 13.8735 23.167 14.6668 23.6297V26.667H8.00016V14.667H24.0002L24.0028 26.667Z",
  fill: "#1442A8"
});

var SvgLocksmith = function SvgLocksmith(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocksmith, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locksmith.33d34de6.svg";
export { ForwardRef as ReactComponent };